import React from 'react';
// import PropTypes from 'prop-types';
import AdCaller from 'helpers/ads/adCaller';
// import CardList from 'components_v2/common/CardList';
import Link from 'components/Link/Link';
import Card from 'components_v2/common/CardV2';
import TrendingSlider from 'components_v2/desktop/TrendingSlider/TrendingSlider';
import Listingheader from '../../../../home/components/common/Listingheader';
import QuickLinks from '../../../components/desktop/QuickLinks';
// import LinksList from '../../../../../components_v2/desktop/LinksList';
import Photo from './Photo';
import s from './Photo.scss';
import CalculatorList from '../../../../calculator/components/mobile/CalculatorList/CalculatorList';
import CardListV5 from '../../../../../components_v2/common/CardListV5/CardListV5';
import { isTablet } from '../../../../../utils/common';
import RHSLinkWidget from '../../../../../components_v2/common/RHSLinkWidget';
import SocialSharingWeb from '../../../../articleshow_v2/components/desktop/SocialSharingWeb';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import TabListingWidget from '../../../../../components_v2/desktop/TabListingWidget/TabListingWidget';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

// const replaceSpacing = val => val.replace(/ /g, '');

const getCalcNameForGa = secName => {
  switch (secName) {
    case 'sip-calc':
      return 'SIP';
    case 'fd-calc':
      return 'FD';
    case 'ppf-calc':
      return 'PPF';
    case 'nps-calc':
      return 'NPS';
    case 'muf-calc':
      return 'Mutual';
    default:
      return 'SIP';
  }
};

const renderTopStoriesRightNow = item => (
  <div className={`${' top_stories'} ${s.rhs_col}`} key={`${item.tn}_1`}>
    {item.name || item.link ? (
      <Listingheader
        headingname={item.name}
        headingLink={item.link}
        size="small"
        newga={`${item.name}Section_Actions#${item.name}_HeadingClick`}
      />
    ) : null}
    <div className="noBorder" key="cover_grid_2">
      {item &&
        item.items &&
        item.items instanceof Array &&
        item.items.map((data, index) => (
          <Card
            key={data.id}
            data={{ ...data, imageid: data.imageid || '25581306' }}
            newga={
              item.id === 'financialnews'
                ? `click_business-news_${index + 1}#${index + 1}_${data.wu}`
                : `TopSection-Actions#TopClick-Grid2/${index}/${data.wu}`
            }
            shouldNotlazyloadImage
            imgWidth="100"
            itemClass={`${s.paddingBottom24} ${
              s.paddingTop12
            } ${'col_l_12'} ${'col_m_12'}`}
          />
        ))}
    </div>
    {item.path &&
      item.id === 'financialnews' && (
        <Link
          to={item.path}
          className={`${s.moreBtn} ${s.moreBtn1}`}
          data={{
            gaLabel: `${item.path}`,
            gaAction: 'click_more-business-news',
            gaCategory: `WEB-CL-finance-calculator_${getCalcNameForGa(
              item.secName,
            )}`,
          }}
        >
          {item.moreText}
        </Link>
      )}
  </div>
);

const renderPhotoGallery = item => (
  <div className={`${' top_stories'} ${s.rhs_col}`} key={`${item.tn}_1`}>
    {item.name || item.link ? (
      <Listingheader
        headingname={item.name}
        headingLink={item.path}
        size="small"
        newga={`${item.name}Section_Actions#${item.name}_HeadingClick`}
      />
    ) : null}
    <div className="noBorder" key="cover_grid_2">
      {item &&
        item.items &&
        item.items instanceof Array &&
        item.items.length > 0 && (
          <CardListV5
            data={item.items}
            featuredItemDisplay={{
              cssObj: {
                figureClass: 'linktype2',
              },
              featuredIndex: 0,
              isLeadTypeTwo: true,
            }}
            nonFeaturedDisplay={{
              tileType: 'default',
              itemWrapperClass: 'rhs-item-wrapper',
              cssObj: {
                figureClass: 'linktype2',
              },
              hideImage: !!isTablet(),
              itemClass: isTablet() && 'linktype1',
              showDuration: false,
              showPhotosCount: true,
              listWrapperClass: 'rhs-list-wrapper',
            }}
            showDescription={false}
            newga={`${item.name}Section_Actions#$typeClick-${item.name}`}
            imgWidth="500"
          />
        )}

      {item &&
        item.moreText &&
        item.moretextlink && (
          <div className="moretextLink">
            <a href={item.moretextlink}>{item.moreText}</a>
          </div>
        )}
    </div>
  </div>
);

export const RenderComponent = (data, type) => {
  // const gaCategory = `WEB${NEWSLISTING_GA_CATEGORY}${sectionName}`;
  let componentReturned;
  switch (type) {
    case 'photolist': {
      componentReturned = <Photo data={data} />;
      break;
    }
    default: {
      componentReturned = null;
    }
  }
  return [componentReturned];
};

export const RenderRhsData = (data, type) => {
  let rhsComponentReturned;
  switch (type) {
    case 'socialshare': {
      rhsComponentReturned = (
        <div className="socialsharerhs">
          <SocialSharingWeb
            loadInView
            // loadableComponentName="SocialSharingWeb"
            title={data?.shareTitle}
            linkeDin
            hideemail
            isWapView={false}
            type="BTF"
            gaCategory=""
            gaAction="click"
            gaIndex="btfFollow_"
            textRequired
            sectionName=""
            url={data?.shareURL}
            via="@timesofindia"
            placeHolderStyles={{ minHeight: '24px' }}
            placeHolderLoaderClass="follow_us_loader"
          />
        </div>
      );
      break;
    }
    case 'ad': {
      rhsComponentReturned = (
        <div className="photolistrhsadcls">
          <AdCaller deviceType="" data={data} />
        </div>
      );
      break;
    }
    case 'column_1_list': {
      rhsComponentReturned = renderTopStoriesRightNow(data);
      break;
    }
    case 'column_1_4_list': {
      rhsComponentReturned = renderPhotoGallery(data);
      break;
    }
    case 'OtherCalc':
      rhsComponentReturned = <CalculatorList {...data} isWapView={false} />;
      break;
    case 'election_side_widget':
      rhsComponentReturned =
        data.items && data.items.length > 0 && Array.isArray(data.items) ? (
          <RHSLinkWidget items={data.items} title={data.hl || data.name} />
        ) : null;
      break;
    case 'election_schdule_iframe':
      rhsComponentReturned = (
        <iframe
          src={data?.src}
          title={data?.name}
          width={data?.width ? data.width : '100%'}
          height={data?.height ? data.height : ''}
          marginWidth={data?.marginWidth ? data.marginWidth : '0'}
          marginHeight={data?.marginHeight ? data.marginHeight : '0'}
          frameBorder={data?.frameBorder ? data.frameBorder : '0'}
          scrolling={data?.scrolling ? data.scrolling : 'no'}
          align={data?.align ? data.align : 'center'}
        />
      );
      break;
    case 'trending_stories':
      rhsComponentReturned = (
        <InViewObserver
          inViewCallback={() => {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: 'trending_widget',
            });
          }}
          viewMargin="50px 0px 50px 0px"
        >
          <TabListingWidget item={data} />
        </InViewObserver>
      );
      break;
    default: {
      rhsComponentReturned = null;
    }
  }
  return rhsComponentReturned;
};

export const RenderQuickLinkComponent = (data, type) => {
  // const gaCategory = `WEB${NEWSLISTING_GA_CATEGORY}${sectionName}`;
  let componentReturned;
  switch (type) {
    case 'column_1_list': {
      componentReturned = <QuickLinks sectionData={data} />;
      break;
    }
    default: {
      componentReturned = null;
    }
  }
  return [componentReturned];
};

export const renderTopSearchesData = (data, type) => {
  let componentReturned;
  switch (type) {
    case 'keywords': {
      if (!(data && Array.isArray(data.items) && data.items.length)) {
        return null;
      }
      componentReturned = (
        <div className="photolistTopsearch">
          <TrendingSlider topSearches={data.items} title={data?.name} />
        </div>
      );
      break;
    }
    default: {
      componentReturned = null;
    }
  }
  return componentReturned;
};
